import { queryOptions } from '@tanstack/react-query';
import { PromoToolSlot } from '@/types/amplience';
import { Locale } from '@/utility/locale';
import { get, toQueryString } from '@/utility/requestHelpers/clientRequestHelpers';
import { getPromoBaseConfig, getPromoKey } from './promoQueryOptionsShared';

export const getPromoBannerQueryOptionsClient = (slotId: string | null, locale: Locale) =>
  queryOptions({
    queryKey: getPromoKey(slotId, locale),
    queryFn: async () =>
      get<PromoToolSlot | null>(
        `/internal/api/promo?${toQueryString({
          locale,
          deliveryKey: slotId,
        })}`
      ),
    ...getPromoBaseConfig(slotId),
  });
